(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Search',
    sortAndFilter: 'Sort + filter',
    close: 'Close',
    search: 'Current search',
    allProducts: 'See all products ',
    matching: 'matching',
    sortBy: 'Sort by',
    filterBy: 'Filter by',
    relevance: 'Relevance',
    outOf: 'out of',
    resultsFound: 'results found',
    oneResultFound: '1 result found',
    noResultFound: 'No result found',
    noProductsFound: 'Sorry, no products found',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    selectedFilter: 'Selected filters',
    clearAll: 'Reset all filters',
    outOfStock: 'Out of stock',
    products: 'Products',
    collections: 'Collections',
    articles: 'Articles',
    pages: 'Pages',
    try: 'Try',
    clearFilters: 'clearing the filters',
    or: 'or',
    changeInput: 'changing your input',
    showLessFacets: 'Show less',
    showMoreFacets:'Show more'
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return 'No result for " ' + text + ' ".';
    },
    in: function(processingTimeMS) {
      return 'in ' + processingTimeMS / 1000 + 's';
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' out of'
      );
    },

    by: function(text) {
      if (!text) return '';
      return ' by ' + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    },

    n_results: function(nbHits) {
      const oneResult = '1 result';
      const nResults = '2 results';
      return nbHits === 1 ? oneResult : nResults.replace("2 ", nbHits + " ");
    },

    title: function(term) {
      const titleWithTerm = 'Search result for “[term]”';
      return (term ? titleWithTerm.replace('[term]', term) : 'Search');
    },

    nothing_found_term: function(term) {
      const stringWithTerm = 'Sorry, nothing found for “[term]”.';
      return stringWithTerm.replace('[term]', term);
    },

    nothing_found_term_try_another: function(term) {
      const stringWithTerm = 'Sorry, nothing found for “[term]”. Please try another keyword.';
      return stringWithTerm.replace('[term]', term);
    }
  };
})(window.algoliaShopify);
